<div class="page-overlay-wrapper" *ngIf="showSpinner">
  <div class="img-container">
    <img src="assets/images/BA-logo.png" class="fg" alt="" />
  </div>
</div>